import React from "react";
import {
  AvailableMainSection,
  CardInnerDiv,
  CardWrapper,
  TextBoxDiv,
} from "./elements";
import { c98cardimg2, connectbtnimg, innerimg, textBox2 } from "assets";
import { Image } from "react-bootstrap";
import { MainCol, MainContainer, MainRow } from "components/common";
import { Link } from "react-router-dom";

const AvailabletoStake = ({ userIds }) => {
  return (
    <AvailableMainSection>
      <TextBoxDiv>
        <Image className="" src={textBox2} />
        <div>
          <h1 className="inner-text">
            Available to <span>Stake</span>
          </h1>
        </div>
      </TextBoxDiv>
      <MainContainer fluid>
        <MainRow>
          {userIds?.map((item) => (
            <MainCol lg={4}>
              <CardWrapper>
                <Image src={c98cardimg2} className="innerimg" />

                <CardInnerDiv>
                  <div className="mask1">
                    <Image src={item.image} fluid />
                  </div>
                  <h1>{item.title}</h1>

                  {/* <div className="content-div">
                    <h5>{item.name1}</h5>
                    <p>{item.value1}</p>
                  </div>
                  <div className="content-div">
                    <h5>{item.name2}</h5>
                    <p>{item.value2}</p>
                  </div> */}
                  {item?.attributes.map((item) => (
                    <>
                      <div className="content-div">
                        <h5>{item.name}</h5>
                        <p>{item.value}</p>
                      </div>
                    </>
                  ))}
                  <div className="register-btn-div">
                    <Image
                      src={connectbtnimg}
                      alt="button img"
                      className="btn-img"
                    />
                    <Link
                      to={{
                        pathname: "/staking-popup",
                        search: `?id=${item.nftId}`,
                      }}
                    >
                      <h1>{item.btnText}</h1>
                    </Link>
                  </div>
                </CardInnerDiv>
              </CardWrapper>
            </MainCol>
          ))}
        </MainRow>
      </MainContainer>
    </AvailableMainSection>
  );
};

export default AvailabletoStake;
